type SolPairMetadataInput = {
  Address?: string;
  Mint?: string;
  base_decimals?: number;
  quote_decimals?: number;
  quote_mint?: string;
  quote_symbol?: string;
  symbol: string;
};

export const solPairMetadata = (pair: SolPairMetadataInput) => {
  const [baseSymbol = '', symbolQuote = ''] = pair.symbol.split('/');

  return {
    poolAddress: pair.Address ?? '',
    baseMint: pair.Mint ?? '',
    baseSymbol,
    baseDecimals: pair.base_decimals ?? 9,
    quoteMint: pair.quote_mint ?? 'So11111111111111111111111111111111111111112',
    quoteSymbol: pair.quote_symbol ?? symbolQuote,
    quoteDecimals: pair.quote_decimals ?? 9,
  };
};
